<template>
  <div class="about-container">
    <div class="user-nav">
      <router-link :to="'about'" class="active">关于我们</router-link>
    </div>
    <p>工程技术标准咨询服务系统（以下简称“服务系统”）由中国对外承包工程商会牵头，联合四川语言桥信息技术有限公司、甲骨易（北京）翻译股份有限公司两家业内专业机构打造，旨在解决我国对外承包工程企业在“走出去”过程中面临的项目所在国家或地区对标准要求严格、企业对部分外国主流标准不熟悉、获取外国标准文件成本高、难度大等痛点问题，提升企业标准管理及应用方面的软实力，切实服务企业生产经营活动。</p>
    <p>服务系统采集了欧洲标准化委员会（EN）、国际铁路联盟（UIC）、美国国家公路与运输协会（AASHTO）、美国材料与试验协会（ASTM）、英国标准协会（BS）、法国标准化协会（NF）、德国标准（DIN）澳大利亚标准、俄罗斯标准、哈萨克斯坦标准等组织的公路、铁路、房建、机场和电力等国外专业标准目录；采集的中国工程技术标准（包括国标和行业标准）目录覆盖建筑、交通、水利水电、石油化工等十几个行业。注册成为服务系统会员后，企业可登陆进行标准目录检索、查阅标准介绍等，还可以提交标准咨询意向，获取更加详尽的技术咨询服务。</p>
  </div>
</template>

<script>
export default {
  name: 'About'
}
</script>

<style lang="scss">
  @import "../../style/user-nav";
  .about-container{}
</style>



// WEBPACK FOOTER //
// src/page/about/About.vue